<div class="b2b-page-download-pdf-cmr"><div class="loading-container"><one-spinner size="large"></one-spinner><p>{{ loadingMessage }}</p></div></div>